<script lang="ts" setup>
import { Code } from '@/api/modules/sales/types'

type Props = {
  code: Code
  isActiveCode: boolean
}
const props = defineProps<Props>()

const emit = defineEmits(['copyPromocode'])

const variantButton = !props.isActiveCode ? 'tertiary' : 'primary'
const promocodeText = props.isActiveCode
  ? 'Кликните на промокод, чтобы скопировать:'
  : 'Промокод неактивен'

const copyPromocode = () => emit('copyPromocode')
</script>

<template>
  <div class="promocode">
    <span v-if="isActiveCode" class="promocode__title">Промокод:</span>

    <div class="promocode__section">
      <div class="promocode__section-text" :class="{ inactive: !isActiveCode }">
        {{ promocodeText }}
      </div>
      <the-button
        :disabled="!isActiveCode"
        :variant="variantButton"
        @click="copyPromocode"
      >
        <span>{{ code?.promocode }}</span>
        <template v-if="isActiveCode" #append>
          <the-icon name="copy" color="var(--ui-white)" />
        </template>
      </the-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.promocode {
  display: grid;
  gap: 10px 0;
  height: max-content;
  color: var(--ui-text-primary);

  &__title {
    font-size: 16px;
    font-weight: 800;
    line-height: 19px;
  }

  &__section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &-text {
      max-width: 200px;
      font-size: 12px;
      font-weight: 600;
      line-height: 19.6px;
    }

    .inactive {
      max-width: max-content;
      font-size: 16px;
      font-weight: 800;
    }
  }
}
</style>
